import { Component, OnInit, Input } from '@angular/core';
import { VIEW_MODE } from '@/app/interfaces/view-mode.enum';
import { CommonModule } from '@angular/common';
import { EoiCreateComponent } from '@/app/components/projects/project-requests/requested-tendering/requested-eois/eoi-create/eoi-create.component';
import { EoiViewComponent } from '@/app/components/projects/project-requests/requested-tendering/requested-eois/eoi-view/eoi-view.component';

@Component({
  selector: 'app-eoi-request-view',
  standalone: true,
  imports: [CommonModule, EoiCreateComponent, EoiViewComponent],
  templateUrl: './eoi-request-view.component.html',
  styleUrl: './eoi-request-view.component.css',
})
export class EoiRequestViewComponent implements OnInit {
  @Input() inputData!: {
    eoiId: number;
    projectId: number;
    tenderingSubType: string;
  };

  isEditMode = true;
  VIEW_MODE = VIEW_MODE;
  mode: VIEW_MODE = VIEW_MODE.EDIT; // NOTE: enum
  expressionData: any;

  ngOnInit(): void {
    /**
     * If inputData is empty/not sent, then try to get value from history state
     */
    if (!this.inputData) {
      const state = history.state;
      if (state) {
        this.inputData = {
          eoiId: state?.eoiId,
          projectId: state?.projectId,
          tenderingSubType: state?.tenderingSubType,
        };
      }
    }
  }

  handleViewChange($event: any) {
    this.mode = $event;
  }

  toggleMode(): void {
    this.isEditMode = !this.isEditMode;
    if (this.isEditMode) {
      this.mode = VIEW_MODE.EDIT;
    } else {
      this.mode = VIEW_MODE.VIEW;
    }
  }
  clickEditProjectBrief() {
    localStorage.setItem('isEdit', String(true));
  }
}
